export default __webpack_public_path__ + "static/media/mark_mueller_head.5be198c9.jpg";